module.exports = __webpack_public_path__ + "static/media/external-link-orange.9a8e33fc.svg";